export default __webpack_public_path__ + "static/media/AQUILONI.1c2cc6e0.jpg";